import { Constants } from "../utils/lib/constants";

export class SnackbarConfiguration implements ISnackbarConfiguration  {
    OnGetSnackbarMessageConfigurations: ISnackbarMessageConfigurations = {
        defaultSuccessMessage: Constants.emptyString,
        defaultErrorMessage: "Unable to retrieve record",

        alwaysDisplaySuccessresultMessage: false,

        displayInforesultMessage: true,
        displaySuccessresultMessage: false,
        displayErrorresultMessage: true,
        displayWarningresultMessage: true,
    };

    OnSaveSnackbarMessageConfigurations: ISnackbarMessageConfigurations = {
        defaultSuccessMessage: "Record succussefully saved.",
        defaultErrorMessage: "Unable to save record",

        alwaysDisplaySuccessresultMessage: true,

        displayInforesultMessage: true,
        displaySuccessresultMessage: true,
        displayErrorresultMessage: true,
        displayWarningresultMessage: true,
    };

    OnDeleteSnackbarMessageConfigurations: ISnackbarMessageConfigurations = {
        defaultSuccessMessage: "Record succussefully deleted.",
        defaultErrorMessage: "Unable to delete record",

        alwaysDisplaySuccessresultMessage: true,

        displayInforesultMessage: true,
        displaySuccessresultMessage: true,
        displayErrorresultMessage: true,
        displayWarningresultMessage: true,
    };
}

export interface ISnackbarConfiguration {
    OnGetSnackbarMessageConfigurations: ISnackbarMessageConfigurations;
    OnSaveSnackbarMessageConfigurations: ISnackbarMessageConfigurations;
    OnDeleteSnackbarMessageConfigurations: ISnackbarMessageConfigurations;
}

export interface ISnackbarMessageConfigurations {
    defaultSuccessMessage: string;
    defaultErrorMessage: string;

    alwaysDisplaySuccessresultMessage: boolean;

    displayInforesultMessage: boolean;
    displaySuccessresultMessage: boolean;
    displayErrorresultMessage: boolean;
    displayWarningresultMessage: boolean;
}

